import { render } from "./CustomerListTable.vue?vue&type=template&id=3667601d&scoped=true"
import script from "./CustomerListTable.vue?vue&type=script&lang=js"
export * from "./CustomerListTable.vue?vue&type=script&lang=js"

import "./CustomerListTable.vue?vue&type=style&index=0&id=3667601d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3667601d"]])

export default __exports__